// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeatureChoice } from './feature-choice';
import { StagedProductPart } from './staged-product-part';
import { StagedProductType } from './staged-product-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StagedProductColor extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(40) */
  approximatePms?: string;
  /** String(100) */
  colorName!: string;
  /** Int32 FK featureChoice */
  featureChoiceId?: number;
  /** Boolean */
  isFeatureChoiceManual!: boolean;
  /** DateTimeOffset */
  snapshotTs!: Date;
  /** Int32 FK stagedProductType */
  stagedProductTypeId!: number;
  /** String(100) */
  standardColorName?: string;
  /** FK featureChoiceId */
  featureChoice!: FeatureChoice;
  /** Inv FK stagedProductColorId */
  stagedProductParts!: StagedProductPart[];
  /** FK stagedProductTypeId */
  stagedProductType!: StagedProductType;
}

